import { render, staticRenderFns } from "./ZiXun.vue?vue&type=template&id=5d785f51&scoped=true&"
import script from "./ZiXun.vue?vue&type=script&lang=js&"
export * from "./ZiXun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d785f51",
  null
  
)

export default component.exports